import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import AirOutlinedIcon from '@mui/icons-material/AirOutlined';
import InvertColorsOutlinedIcon from '@mui/icons-material/InvertColorsOutlined';
import BubbleChartOutlinedIcon from '@mui/icons-material/BubbleChartOutlined';
import LocalParkingOutlinedIcon from '@mui/icons-material/LocalParkingOutlined';

import Tooltip from '@mui/material/Tooltip';

export default function DashboardPower() {
  const state = useContext(MainContext).state;
  const rc = state.RC.split(',');

  const rows = [
    { id: 0, label: 'Heater', icon: <LocalFireDepartmentOutlinedIcon />, value: rc[1] === '1' ? 'On' : 'Off' },
    { id: 1, label: 'Circ', icon: <AirOutlinedIcon />, value: rc[2] === '1' ? 'On' : 'Off' },
    { id: 2, label: 'O3', icon: <InvertColorsOutlinedIcon />, value: rc[3] === '1' ? 'On' : 'Off' },

    {
      id: 3,
      label: 'Blower',
      icon: <BubbleChartOutlinedIcon />,
      value: rc[10] === '0' ? 'Vari' : rc[10] === '1' ? 'Ramp' : 'Off'
    },

    { id: 4, label: 'P1', icon: <LocalParkingOutlinedIcon />, value: rc[4] === '1' ? 'On' : 'Off' },
    { id: 5, label: 'P2', icon: <LocalParkingOutlinedIcon />, value: rc[5] === '1' ? 'On' : 'Off' },
    { id: 6, label: 'P3', icon: <LocalParkingOutlinedIcon />, value: rc[7] === '1' ? 'On' : 'Off' },
    { id: 7, label: 'P4', icon: <LocalParkingOutlinedIcon />, value: rc[8] === '1' ? 'On' : 'Off' },
  ];

  const POWER_TOOLTIPS = {
    Heater: 'Heater',
    Circ: 'Circulation',
    O3: 'Ozone',
    Blower: 'Blower',
    P1: 'Pump 1',
    P2: 'Pump 2',
    P3: 'Pump 3',
    P4: 'Pump 4',
  };

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        color="white"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Power
      </Typography>

      <Grid container spacing={1.5}>
        {rows.map((item) => {
          const isOn = item.value === 'On';
          const isBlower = item.label === 'Blower';

          const blowerBlue = item.value === 'Vari' || item.value === 'Ramp';

          const tooltipText = POWER_TOOLTIPS[item.label];

          const card = (
            <Paper
              sx={{
                p: 1.2,
                height: 60,
                display: 'flex',
                alignItems: 'center',
                gap: 1.2,
                borderRadius: 2,

                bgcolor: isBlower
                  ? blowerBlue
                    ? 'rgba(33,150,243,0.12)'
                    : 'rgba(255,255,255,0.04)'
                  : 'rgba(255,255,255,0.04)',

                border: '1px solid',
                borderColor: isBlower
                  ? blowerBlue
                    ? 'rgba(33,150,243,0.5)'
                    : 'rgba(255,255,255,0.1)'
                  : 'rgba(255,255,255,0.1)',

                transition: '0.2s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  bgcolor: isBlower
                    ? blowerBlue
                      ? 'rgba(33,150,243,0.22)'
                      : 'rgba(255,255,255,0.08)'
                    : 'rgba(255,255,255,0.08)',
                },
              }}
            >
              {/* Icon bubble */}
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',

                  bgcolor: isBlower
                    ? blowerBlue
                      ? 'rgba(33,150,243,0.9)'
                      : 'rgba(255, 255, 255, 0.05)'
                    : isOn
                      ? 'success.main'
                      : 'rgba(255, 255, 255, 0.05)',

                  color:
                    (isBlower && blowerBlue) || isOn
                      ? '#000'
                      : 'rgba(50,116,162,1)',

                  flexShrink: 0,
                }}
              >
                {item.icon}
              </Box>

              {/* Label + value */}
              <Box sx={{
                  flexGrow: 1,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: 0.3, 
                  mt: 0.4
                }}>
                <Typography
                  color="white"
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: 1.1,
                  }}
                  noWrap
                >
                  {item.label}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: isBlower
                      ? blowerBlue
                        ? 'rgba(144,202,249,1)'
                        : 'rgba(255,255,255,0.6)'
                      : isOn
                        ? 'success.main'
                        : 'rgba(255,255,255,0.6)',
                    fontSize: 13,
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            </Paper>
          );

          return (
            <Grid item xs={6} key={item.id}>
              {tooltipText ? (
                <Tooltip title={tooltipText} arrow placement="top">
                  <Box>{card}</Box>
                </Tooltip>
              ) : (
                card
              )}
            </Grid>
          );
        })}
      </Grid>
    </React.Fragment>
  );
}
